import React from "react";
import { useEffect, useState } from "react"
import { CloseIcon } from "../assets/icons/icon-close";
import { ModalSystem } from "../systems";
import { ModalInternalView, ModalSize } from "../systems/modal.system";


interface ModalProps {

}



export const Modal = () => {

    let [modals, setModals] = useState<ModalInternalView[]>([]);

    const onModalChange = () => setModals(ModalSystem.modalViews);

    useEffect(() => {

        setModals(ModalSystem.modalViews);
        ModalSystem.onChange.subscribe(onModalChange);
        return () => {
            ModalSystem.onChange.unsubscribe(onModalChange);
        };


    }, [])

    const getModalSize = (size: ModalSize): string => {
        switch (size) {
            case "micro": return "w-1/12 ";
            case "small": return "w-4/12 ";
            case "medium": return "w-6/12 h-1/4";
            case "large": return "w-11/12 h-5/6";

            default:
                break;
        }
    }





    return (

        <>
            {
                modals
                    .filter(m => m.visibility)
                    .map(m => {

                        const Component = m.component;
                        return (
                            <div className={`
                            bg-gray-900 
                            bg-opacity-50 
                            fixed 
                            w-full h-full 
                            flex 
                            place-content-center
                            items-center
                            cursor-pointer
                            z-30 
                            `}
                                key={m.id}
                                onClick={() => m.parameters.canClose && ModalSystem.hide(m.id)}
                            >


                                <div
                                    onClick={(e) => e.stopPropagation()}
                                    className={`
                                        bg-white 
                                        shadow-xl
                                        rounded 
                                        flex 
                                        flex-column
                                        p-3 
                                        animate-slidedown
                                        
                                        ${getModalSize(m.parameters.size)}`}>
                                    <div className="flex justify-start">
                                        <span className="flex-grow font-medium text-lg">{m.title}</span>
                                        <CloseIcon
                                            size={18}
                                            className="self-start align-top"
                                            onClick={() => ModalSystem.hide(m.id)} />
                                    </div>
                                    <div className="content h-full">
                                        <Component {...m.props} id={m.id} />
                                    </div>
                                </div>
                            </div>
                        )
                    })

            }
        </>
    );



}